/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
import { makeApi, URLS } from 'Utils/apiUtil';
import { userDetail } from 'Stores/userDetail';
import { commonAppData } from 'Stores/commonAppData';
import { Utils } from 'Utils/utils';
import { trialUserOnboardingState } from 'Stores/trialUserOnboardingState';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import * as CONSTANTS from './constants';
import { suppressionListUploadState } from '../components/common/suppressionListUploadPopup';
import advSearchState from '../stores/advSearch';

const { MX_PROFILE_PROPERTIES } = CONSTANTS;

const removeAutoLoginKeyFromUrl = (url = window.location.href) => {
  const newUrl = url.replace(/ak=[a-zA-Z0-9]+&?/, '');

  window.history.replaceState(null, null, newUrl);
};

export const loginValidate = async (
  additionalOperation,
  isFirstLoad = false,
) => {
  const pageUrl = window.location.href;
  let autoLoginKey = null;
  if (pageUrl.includes('ak='))
    autoLoginKey = Utils.getQueryParamFromUrl('ak', pageUrl);

  const windowUrl = window.location.href;
  let isGetSuppressionListTriggered = false;
  if (
    windowUrl.includes('/advanced-search/') &&
    windowUrl.includes('#search') &&
    isFirstLoad
  ) {
    isGetSuppressionListTriggered = true;
    suppressionListUploadState.getSuppressionList();
  }
  try {
    const config = {
      url:
        URLS.loginValidation +
        (autoLoginKey !== null ? `?ak=${autoLoginKey}` : ''),
      method: 'GET',
    };

    // eslint-disable-next-line no-return-await
    const response = await makeApi(config);

    if (Utils.isProductionEnv())
      import('@sentry/react').then(Sentry => {
        const email = response.data?.member?.email;
        if (Utils.isNotUndefinedNotNull(email)) Sentry.setUser({ email });
      });

    const userObj = {};
    if (response && response.data && response.data !== '') {
      const {
        member,
        team = null,
        memberSubscription = null,
        purchaseLimit = 5000,
        currentPlanDisplayName = null,
        trialOnboardingDetail = null,
        businessEmail,
        paymentPending = null,
        apiCredits = null,
        suppressionListEmailLimit = 25000,
        remainingIndividualLbCredits,
        isSetPassword = false,
      } = response && response.data;
      if (member) {
        const {
          conciergeCredits = 0,
          emailUpdateHistory,
          secondaryEmailUpdateHistory,
          userInterestList,
          hubspotEnrichmentSteps,
          searchFilterFlags,
        } = member;
        userObj.conciergeCredits = conciergeCredits;
        userObj.email = member.email;
        userObj.remainingIndividualLbCredits =
          remainingIndividualLbCredits !== undefined &&
          remainingIndividualLbCredits !== null
            ? remainingIndividualLbCredits
            : -1;
        userObj.lbCreditsPlan = member.lbCreditsPlan || false;
        userObj.memberId = member.id ? member.id : '';
        userObj.salesgearApiKey =
          // eslint-disable-next-line camelcase
          member?.crmPreferences?.SALESGEAR?.api_key || '';
        userObj.secondaryEmail = member?.secondaryEmail;
        userObj.secondaryEmailStatus = member?.secondaryEmailStatus;

        userObj.secondaryHsEmail = member.trialHubspotData
          ? member.trialHubspotData.email
          : '';
        userObj.emailUpdateHistory = emailUpdateHistory || [];
        userObj.secondaryEmailUpdateHistory = secondaryEmailUpdateHistory || [];
        userObj.isSetPassword = isSetPassword;
        userObj.userInterestList = userInterestList;
        userObj.hubspotEnrichmentSteps = hubspotEnrichmentSteps;

        if (Utils.isNotUndefinedNotNull(searchFilterFlags)) {
          const dataFromAPI = {
            showContactsWithEmail: Utils.isNotUndefinedNotNull(
              searchFilterFlags.showContactsWithEmail,
            )
              ? searchFilterFlags.showContactsWithEmail
              : true,
            showContactsWithoutEmail: Utils.isNotUndefinedNotNull(
              searchFilterFlags.showContactsWithoutEmail,
            )
              ? searchFilterFlags.showContactsWithoutEmail
              : false,
          };
          advSearchState.checkBoxFilters = {
            ...advSearchState.checkBoxFilters,
            ...dataFromAPI,
          };
          userObj.searchFilterFlags = dataFromAPI;
        } else {
          userObj.searchFilterFlags = {
            showContactsWithEmail: true,
            showContactsWithoutEmail: false,
          };
        }

        if (isFirstLoad) {
          if (trialOnboardingDetail !== null)
            trialUserOnboardingState.setTrialInfoDetail(trialOnboardingDetail);

          if (memberSubscription !== null) {
            const {
              freeTrial = false,
              enterpriseFreeTrial = false,
              price = 0,
            } = memberSubscription;
            userDetail.setIsFreeTrial(freeTrial);
            userObj.isFreeTrial = freeTrial;
            userDetail.setIsEnterpriseFreeTrial(enterpriseFreeTrial);

            if (!freeTrial)
              Utils.mixpanelUpdateProfileProperty({
                [MX_PROFILE_PROPERTIES.PLAN_PRICE]: price,
              });

            Utils.mixpanelUpdateProfileProperty({
              [MX_PROFILE_PROPERTIES.ENTERPRISE_TRIAL]: enterpriseFreeTrial,
            });
          }
        }
        userObj.name = member.name || `${member.firstName} ${member.lastName}`;
        userObj.firstName = member.firstName;
        userObj.lastName = member.lastName;
        userObj.apiKey = member.apiKey ? member.apiKey : '';
        userObj.pluginInstalled = member.pluginInstalled || false;
        userObj.timeZone = member.timeZone ? member.timeZone : '';
        userObj.emailPreferences = member.emailPreferences
          ? member.emailPreferences
          : '';
        userObj.crmPreferences = member.crmPreferences
          ? member.crmPreferences
          : null;
        userObj.connectedLinkedInData = member.connectedLinkedInData
          ? member.connectedLinkedInData
          : '';
        userObj.trialUsed = member.trialUsed ? member.trialUsed : false;
        userObj.type = member.type !== null ? member.type : 0;
        userObj.trialHubspotData = member.trialHubspotData;
        userObj.phone = member.phone;
        userObj.jobRole = member.jobRole;

        userObj.isEnterpriseUser = member.enterpriseUser
          ? member.enterpriseUser
          : false;
        userObj.userStatus =
          member.status !== undefined && member.status !== null
            ? member.status
            : 2;

        userObj.pageSource = member.pageSource;

        userObj.role =
          member.role !== undefined && member.role !== null
            ? member.role
            : 'ROLE_MEMBER';
        userObj.onboardingCompleted =
          member.onboardingCompleted !== undefined &&
          member.onboardingCompleted !== null
            ? member.onboardingCompleted
            : false;

        userObj.memberOnboardingInfo = member.memberOnboardingInfo || null;

        userObj.creationTimeStamp =
          member.creationTimeStamp !== undefined &&
          member.creationTimeStamp !== null
            ? member.creationTimeStamp
            : '';

        if (
          member.uiVersion !== undefined &&
          member.uiVersion !== null &&
          member.uiVersion === 'A'
        )
          window.location.href = CONSTANTS.WEB_URL;
      }

      userObj.paymentPending = paymentPending;

      userObj.businessEmail = businessEmail;
      userObj.userLoggedIn = true;

      if (team !== null) {
        userObj.noOfSeatsEligible = team.noOfSeatsEligible;
        userObj.noOfSeatsUsed = team.noOfSeatsUsed;
        userObj.creditLimitEnabled = team.creditLimitEnabled || false;
        userObj.phoneVendorPurchaseEnabled =
          team.phoneVendorPurchaseEnabled || false;
        userObj.teamCRMPreferences = team?.crmAccount || {};
      }
      const { noOfSeatsEligible = 0, noOfSeatsUsed = 0 } = userObj;

      Utils.mixpanelUpdateProfileProperty({
        [MX_PROFILE_PROPERTIES.SEAT_ELIGIBLE]: noOfSeatsEligible,
        [MX_PROFILE_PROPERTIES.SEAT_USED]: noOfSeatsUsed,
      });

      userObj.userPlanMX =
        currentPlanDisplayName !== undefined && currentPlanDisplayName !== null
          ? currentPlanDisplayName
          : 'Free Forever';
      userObj.currentPlan = response.data.currentPlan
        ? response.data.currentPlan
        : '';
      userObj.currentPlanDisplayName = response.data.currentPlanDisplayName
        ? response.data.currentPlanDisplayName
        : '';
      userObj.isEnterpriseAdmin = response.data.isEnterpriseAdmin
        ? response.data.isEnterpriseAdmin
        : false;
      userObj.teamAdminEmail = response.data.teamAdminEmail
        ? response.data.teamAdminEmail
        : '';
      userObj.isTeamPlan = response.data.isTeamPlan
        ? response.data.isTeamPlan
        : false;

      userObj.apiCredits = apiCredits;
      const {
        views,
        downloads,
        lbCredits,
        phoneCreditsRemaining,
        enrichmentCreditsRemaining,
      } = team || member;
      userObj.teamId = team ? team.id : null;
      userObj.enrichmentCreditsRemaining = enrichmentCreditsRemaining || 0;
      if (userObj.lbCreditsPlan) {
        userObj.lbCredits = lbCredits;
        userObj.phoneCreditsRemaining = phoneCreditsRemaining;
        if (userDetail.isFreeTrial)
          Utils.mixpanelUpdateProfileProperty({
            [MX_PROFILE_PROPERTIES.CREDITS_REMAINING]: lbCredits,
          });
      } else {
        userObj.views = views;
        userObj.downloads = downloads;
      }

      userObj.purchaseLimit = purchaseLimit;
      userObj.suppressionListEmailLimit = suppressionListEmailLimit;
      userObj.memberSubscription = memberSubscription;
      userObj.source = member.source;
      userObj.mixpanelData = member.mixpanelData;
      userObj.demoRequested = member.demoRequested;

      if (userDetail.isFreeTrial && trialOnboardingDetail !== null)
        trialUserOnboardingState.handleOptionalFlows(
          userObj,
          trialOnboardingDetail,
        );

      userDetail.setUserInfo(userObj);

      if (autoLoginKey !== null) {
        setTimeout(() => {
          removeAutoLoginKeyFromUrl();

          if (additionalOperation) {
            if (!userDetail.onFirstLoad) getFeatureFlags(isFirstLoad);
            myLeadsList(isFirstLoad);
          }
        }, 500);
      } else if (additionalOperation) {
        if (!userDetail.onFirstLoad) getFeatureFlags(isFirstLoad);
        myLeadsList(isFirstLoad);
      }

      if (isFirstLoad) {
        getContactSavedSearches();
        savedSearches('company');
        getSubscriptionPlans();
        getHubspotCalendarLink();

        commonAppData.getAndSetIndustryFullData();
        // commonAppData.getAndSetTechnologiesFilterInitialData();
        if (!isGetSuppressionListTriggered)
          suppressionListUploadState.getSuppressionList();
        if (userObj.salesgearApiKey) getSalesgearUserDetail();
      }

      // if (isFirstLoad) Utils.sendAttributeToHotjar();

      // g2 popup logic
      Utils.checkAndShowG2Popup();

      if (isFirstLoad) return response;
      // return true;
    }
    return false;
  } catch (error) {
    console.log('loginValidate error ', error);
  }
};

export const logout = () => {
  const config = {
    url: URLS.logout,
    method: 'POST',
  };
  makeApi(config, false)
    .then(response => {
      Utils.mixpanelReset();
      Utils.removeLocalStorage('companySearch');
      Utils.removeLocalStorage('companySerPostData');
      Utils.removeLocalStorage('searchJson');
      Utils.deleteCookie('seo_contact_url');
      Utils.deleteCookie('seo_search');
      Utils.removeLocalStorage('showIndustrySearchCompany');
      Utils.removeLocalStorage('showIndustrySearch');
      Utils.deleteCookie('ask_userOnBoarding');
      document.cookie = 'li=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      window.location.href = CONSTANTS.WEB_URL;
    })
    .catch(error => {
      console.log('logout error ', error);
    });
};

export const getFeatureFlags = (isFirstLoad = false) => {
  const config = {
    url: URLS.getFeatureFlags,
    method: 'GET',
  };
  makeApi(config)
    .then(response => {
      if (response && response.data)
        userDetail.setUserFeatureFlags(response.data);

      if (!userDetail.onFirstLoad) userDetail.setInitialLoad(true);
    })
    .catch(error => {
      console.log('savedSearches error ', error);
    });
};

export const savedSearches = (searchType = 'contact') => {
  const config = {
    url: URLS.savedSearch + searchType,
    method: 'GET',
  };
  makeApi(config)
    .then(response => {
      if (response && response.data)
        userDetail.setSavedSearches(response.data, searchType);
    })
    .catch(error => {
      console.log('savedSearches error ', error);
    });
};

export const getContactSavedSearches = async () => {
  const config = {
    url: Utils.generateUrl(URLS.savedSearchV2, {
      searchType: 'CONTACT',
      limit: 700,
    }),
    method: 'GET',
  };
  const response = await makeApi(config);
  if (response && response.data && response.data.savedSearchList)
    userDetail.setSavedSearches(response.data.savedSearchList, 'contact');
  if (
    response.data?.creatorsName &&
    Object.keys(userDetail.sharedListAuthorData).length === 0
  )
    userDetail.sharedListAuthorData = response.data.creatorsName;
};

export const myLeadsList = (isFirstLoad = false) => {
  const config = {
    url: userDetail.userInfo.teamId
      ? `${URLS.myList.list}?teamId=${userDetail.userInfo.teamId}`
      : URLS.myList.list,
    method: 'GET',
  };
  makeApi(config)
    .then(response => {
      if (!userDetail.myLeadListLoaded) userDetail.myLeadListLoaded = true;
      if (response && response.data) {
        if (response.data.contactList) {
          let updatedList = [];
          updatedList = (
            response.data.contactList?.map(list => {
              if (!list.id) return { ...list, id: null };
              return list;
            }) || []
          ).concat(response.data.sharedList || []);

          userDetail.setMyLeadList(updatedList);
        }
        if (response.data?.creatorsName)
          userDetail.sharedListAuthorData = response.data.creatorsName;

        if (isFirstLoad)
          if (response.data.isListBuildingEnabled !== undefined)
            userDetail.setIsMyLeadEnbled(response.data.isListBuildingEnabled);
          else userDetail.setIsMyLeadEnbled(false);
      }
    })
    .catch(error => {
      if (!userDetail.myLeadListLoaded) userDetail.myLeadListLoaded = true;
      console.log('myLeadsList error ', error);
    });
};

export const getSubscriptionPlans = () => {
  const config = {
    url: URLS.getSubscriptionPlans,
    method: 'GET',
  };
  makeApi(config)
    .then(response => {
      // console.log('myLeadsList response  ', response);

      if (
        response &&
        response.status &&
        response.status === 200 &&
        response.data
      ) {
        const {
          subscriptionPlans = [],
          currentSubscriptionPlan = {},
          currentPlan = null,
        } = response.data;
        const { name, displayName } = currentSubscriptionPlan;
        userDetail.setSubscriptionPlans(subscriptionPlans);
        if (currentPlan) {
          const planInfo = { ...currentPlan, name, displayName };
          userDetail.setCurrentSubscriptionPlanInfo(planInfo);
        }
      }
    })
    .catch(error => {
      console.log('getSubscriptionPlans error ', error);
    });
};

export const getHubspotCalendarLink = () => {
  const config = {
    url: URLS.getHubspotCalendarLink,
    method: 'GET',
  };
  makeApi(config)
    .then(response => {
      if (response && response.data && response.data.link)
        userDetail.setHubspotCalendarLink(response.data.link);
    })
    .catch(error => {
      console.log('getHubspotCalendarLink error ', error);
    });
};

export const updatePaidUserWelcomePopupShown = subscriptionId => {
  const config = {
    url: URLS.updatePaidUserWelcomePopupShown,
    method: 'POST',
    data: {
      subscriptionId,
    },
  };
  makeApi(config, false)
    .then(response => {})
    .catch(error => {
      console.log('updatePaidUserWelcomePopupShown error ', error);
    });
};

export const updateMemberOnboardingInfo = (data = {}) => {
  const config = {
    url: URLS.updateMemberOnboardingInfo,
    method: 'POST',
    data,
  };
  makeApi(config, false)
    .then(response => {})
    .catch(error => {
      console.log('updateMemberOnboardingInfo error ', error);
    });
};

export const getSalesgearUserDetail = async () => {
  try {
    const config = {
      url: URLS?.salesgear?.getUserDetail,
      method: 'GET',
    };
    const res = await makeApi(config);
    if (res?.data) userDetail.setSalesgearUserInfo(res.data);
  } catch (e) {
    console.log('Getting salesgear user detail failed', e);
  }
};

export const resendActivationLink = email => {
  const config = {
    url: URLS.resendEmailConfirmation,
    method: 'POST',
    data: {
      email,
    },
  };
  makeApi(config)
    .then(response => {
      if (response && response.data !== undefined && response.data === 'true')
        purchaseStatusPopupState.setToastMsg(
          null,
          null,
          null,
          null,
          null,
          'Activation link sent successfully.',
        );
    })
    .catch(error => {
      console.log('resend Activation Link error ', error);
    });
};
